import React from 'react';
import PropTypes from 'prop-types';
import CallIcon from 'material-ui/svg-icons/communication/phone';
import get from 'lodash.get';

const PhoneNumberWidget = ({ value, placeholder, onChange }) => (
  <div>
    <input
      type="text"
      class="form-control"
      value={value}
      label="Mobile"
      placeholder={placeholder}
      onChange={(e, newValue) =>
        onChange(newValue || get(e, 'target.value') || value)
      }
    />
    <a
      className="btn btn-default btn-xs"
      href={`tel:${value || ''}`}
      style={{ float: 'right', marginTop: '-35px' }}
    >
      <CallIcon />
    </a>
  </div>
);
PhoneNumberWidget.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};
export default PhoneNumberWidget;



// WEBPACK FOOTER //
// ./src/components/PhoneNumberWidget.js